<template>
  <div>
    {{ payload.score }}
  </div>
</template>

<script>
export default {
  name: 'OperationScore',
  props: {
    payload: {
      type: Object,
      required: true
    }
  }
}
</script>
